import React from "react";
import classNames from "classnames";
import Icon, { IconNames } from "../../../../Foundation/Icons";
import { IconColours } from "../../../../Foundation/Icons/interface";
import ImageWrapper from "../../../ImageWrapper";
import { ImageTypes } from "../../../ImageWrapper/interface";
import { MediaCardProps } from "../../interface";
import MediaCardPlaceholder from "./mediaCardPlaceholder";
import classes from "./mediaCard.module.scss";
import { getFormattedDuration } from "../../../../../utils/dateTime/library";

const MediaCard = ({
    item,
    aspectRatio,
    showIcon,
    displayDuration,
}: MediaCardProps) => {
    const { id, title, image, media } = item;
    if (!id || !image) {
        return <MediaCardPlaceholder aspectRatio={aspectRatio} />;
    }
    const cardClasses = classNames(classes.card, {
        [classes.verticalVideo]: aspectRatio === 0.5625,
        [classes.horizontalVideo]: aspectRatio === 1.7778,
    });

    const accessibilityTitle = title ? `${title}, play video` : "Video content";
    const videoTime = getFormattedDuration(
        media?.duration ? media.duration : 0
    );

    const playButton = showIcon && (
        <Icon
            type="filled"
            name={IconNames.Play}
            colour={IconColours.white}
            title={accessibilityTitle}
            ariaHidden={true}
            className={classes.playButton}
        />
    );

    const displayElements = (
        <React.Fragment>
            <div className={classes.imageContainer}>
                <ImageWrapper
                    imageType={ImageTypes.Image}
                    aspectRatio={aspectRatio}
                    {...image}
                />
                {playButton}
                {displayDuration && (
                    <div className={classes.videoTimeContainer}>
                        <span className={classes.videoTimeStamp}>
                            {videoTime}
                        </span>
                        <Icon
                            type="filled"
                            name={IconNames.ClosedCaptions}
                            colour={IconColours.white}
                            ariaHidden={true}
                            size="18"
                        />
                    </div>
                )}
            </div>
            <div className={classes.headlineWrap}>
                <span className={classes.headline}>{title}</span>
            </div>
        </React.Fragment>
    );

    return (
        <div className={cardClasses} data-testid="mediaCard">
            {displayElements}
        </div>
    );
};

export default MediaCard;
